// src/components/Navbar.js
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.webp";
import AuthModal from "./AuthModal";
import ProfileModal from "./ProfileModal";
import Toast from "./Toast";
import { useUser } from "../context/UserContext";
import { useProfile } from "../context/ProfileContext";

function Navbar() {
  const { user, setUser, showAuthModal, closeLoginModal, openLoginModal } = useUser();
  const { isProfileOpen, activeTab, openProfile, closeProfile, setActiveTab } = useProfile();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("no-scroll", isMenuOpen);
  }, [isMenuOpen]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const handleLogout = () => {
    setUser(null);
    setToastMessage("Logged out successfully");
    closeProfile();
  };

  const handleLoginSuccess = (userData) => {
    setUser(userData);
    closeLoginModal();
    setToastMessage(`Welcome, ${userData.first_name || userData.phone}!`);
  };

  const handleProfileUpdate = (updatedUser) => {
    setUser(updatedUser);
    setToastMessage("Profile updated successfully");
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <NavLink to="/" onClick={closeMenu}>
          <img src={logo} alt="logo" className="navbar-logo" />
        </NavLink>

        <div className="navbar-toggle" onClick={toggleMenu}>
          {isMenuOpen ? (
            <i className="fas fa-times"></i>
          ) : (
            <div className="hamburger">
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}
        </div>

        <div
          className={`mobile-menu-overlay ${isMenuOpen ? "active" : ""}`}
          onClick={closeMenu}
        ></div>

        <ul className={`navbar-links ${isMenuOpen ? "open" : ""}`}>
          <li><NavLink to="/" end onClick={closeMenu}>Home</NavLink></li>
          <li><NavLink to="/order-online" onClick={closeMenu}>Order</NavLink></li>
          <li><NavLink to="/buffet" onClick={closeMenu}>Buffet Reservations</NavLink></li>
          <li><NavLink to="/private-events" onClick={closeMenu}>Event Halls</NavLink></li>
          {/* <li><NavLink to="/book-table" onClick={closeMenu}>Reservations</NavLink></li> */}
          <li><NavLink to="/contact" onClick={closeMenu}>Contact</NavLink></li>

          {!user ? (
            <li>
              <span
                className="login-link"
                onClick={() => {
                  closeMenu();
                  openLoginModal();
                }}
              >
                Log in
              </span>
            </li>
          ) : (
            <li>
              <span
                className="login-link"
                onClick={() => {
                  closeMenu();
                  openProfile("profile"); // open profile via context
                }}
              >
                Profile
              </span>
            </li>
          )}
        </ul>
      </nav>

      {/* Auth Modal */}
      {showAuthModal && (
        <AuthModal onClose={closeLoginModal} onLoginSuccess={handleLoginSuccess} />
      )}

      {/* Profile Modal */}
      {isProfileOpen && user && (
        <ProfileModal
          user={user}
          activeTab={activeTab}
          onClose={closeProfile}
          onLogout={handleLogout}
          onUpdate={handleProfileUpdate}
          setActiveTab={setActiveTab}
        />
      )}

      {/* Toast */}
      {toastMessage && (
        <Toast message={toastMessage} onClose={() => setToastMessage("")} duration={3000} />
      )}
    </>
  );
}

export default Navbar;
